import styled from 'styled-components';

export const Container = styled.div`
  padding: 30px;
  background: #1a1d35;
  min-height: 100vh;
`;

export const Header = styled.div`
  margin-bottom: 30px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 10px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #a8a8b5;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

export const StatCard = styled.div`
  background: #272B4A;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const StatLabel = styled.div`
  font-size: 13px;
  color: #a8a8b5;
  margin-bottom: 8px;
`;

export const StatValue = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
`;

export const FiltersContainer = styled.div`
  background: #272B4A;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FilterLabel = styled.label`
  font-size: 13px;
  color: #a8a8b5;
  font-weight: 500;
`;

export const FilterInput = styled.input`
  background: #1a1d35;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  color: #ffffff;
  outline: none;
  transition: all 0.2s;

  &:focus {
    border-color: #4a90e2;
  }

  &::placeholder {
    color: #6b6b7b;
  }
`;

export const FilterSelect = styled.select`
  background: #1a1d35;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  color: #ffffff;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;

  &:focus {
    border-color: #4a90e2;
  }

  option {
    background: #272B4A;
    color: #ffffff;
  }
`;

export const FilterActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const Button = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  outline: none;

  ${props => props.primary ? `
    background: #4a90e2;
    color: #ffffff;
    
    &:hover {
      background: #357abd;
    }
  ` : `
    background: transparent;
    color: #a8a8b5;
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    &:hover {
      border-color: rgba(255, 255, 255, 0.2);
      color: #ffffff;
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LogsContainer = styled.div`
  background: #272B4A;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const LogsTable = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.02);
  }
`;

export const TableHeader = styled.th`
  padding: 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #a8a8b5;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TableCell = styled.td`
  padding: 15px 12px;
  font-size: 14px;
  color: #ffffff;
  vertical-align: top;
`;

export const ActionBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  
  ${props => {
    switch(props.action) {
      case 'CREATE':
        return 'background: rgba(76, 175, 80, 0.15); color: #4caf50;';
      case 'UPDATE':
        return 'background: rgba(255, 152, 0, 0.15); color: #ff9800;';
      case 'DELETE':
        return 'background: rgba(244, 67, 54, 0.15); color: #f44336;';
      case 'LOGIN':
        return 'background: rgba(33, 150, 243, 0.15); color: #2196f3;';
      case 'LOGOUT':
        return 'background: rgba(158, 158, 158, 0.15); color: #9e9e9e;';
      default:
        return 'background: rgba(156, 39, 176, 0.15); color: #9c27b0;';
    }
  }}
`;

export const UserTypeBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: rgba(96, 125, 139, 0.15);
  color: #607d8b;
  text-transform: capitalize;
`;

export const EntityBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: rgba(103, 58, 183, 0.15);
  color: #673ab7;
  text-transform: capitalize;
`;

export const TimeStamp = styled.div`
  font-size: 13px;
  color: #a8a8b5;
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
`;

export const PageInfo = styled.div`
  font-size: 14px;
  color: #a8a8b5;
`;

export const PageControls = styled.div`
  display: flex;
  gap: 10px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
`;

export const LoadingText = styled.div`
  font-size: 16px;
  color: #a8a8b5;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
`;

export const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.3;
`;

export const EmptyText = styled.div`
  font-size: 16px;
  color: #a8a8b5;
  margin-bottom: 8px;
`;

export const EmptySubtext = styled.div`
  font-size: 14px;
  color: #6b6b7b;
`;
